<template>
  <div>
    <v-dialog v-model="dialog" max-width="85%" @click:outside="closeDialog" v-show="showDialog" class="elevation-10">
      <v-form ref="form" lazy-validation @input="formToggled">
        <v-card tile>
          <v-card-title class="headline" primary-title>
            {{ title }}
            <v-icon color="accent">mdi-arrow-down-circle</v-icon>
            <v-spacer></v-spacer>
            <v-btn @click="skipDescription" color="red darken-1" v-if="title.includes('Describe product')">
              SKIP DESCRIPTION
              <v-icon right> mdi-skip-forward </v-icon></v-btn>
          </v-card-title>
        </v-card>

        <v-card tile v-if="
          type == 'description' ||
          type == 'resolve' ||
          type == 'resolvePlatform'
        ">
          <v-card-title class="subtitle-1 grey accent" primary-title>
            <div>Add photos</div>
          </v-card-title>
          <v-card-text>
            <div style="visibility: hidden; opacity: 0" id="dropzone">
              <div id="textnode">Drop anywhere!</div>
            </div>

            <v-row class="mt-3">
              <v-col class="my-2" cols="1" v-for="(item, i) in product.Photos" :key="i">
                <v-card class="ma-0 pa-0">
                  <v-card-text class="ma-0 pa-0">
                    <expandable-image :src="item"> </expandable-image>
                  </v-card-text>
                  <v-card-actions class="pa-0 ma-0">
                    <v-btn :key="item" text fab @click="deletePhoto(item, i)">
                      <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-file-input v-model="files" placeholder="Upload photos..." multiple prepend-icon="mdi-paperclip"
                  outlined color="accent" :rules="[maxRule]" accept="image/png, image/jpeg, image/jpg" dense chips
                  small-chips @change="validateFiles">
                </v-file-input>
              </v-col>
              <v-col cols="6" class="py-0">
                <v-combobox v-model="photoURLs" multiple chips small-chips deletable-chips label="URL's" outlined dense
                  color="accent" :rules="[maxRule, isURL]">
                </v-combobox>
              </v-col>
            </v-row>
            <v-row class="py-0 my-0">
              <v-spacer></v-spacer>
              <v-col cols="auto" class="my-0 py-0">
                <span :class="this.photoError ? 'red--text' : ''">{{ current }}/{{ max }}</span></v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card tile>
          <v-card-title class="subtitle-1 grey accent" primary-title>
            <div>Required information</div>
          </v-card-title>
          <v-card-text>

            <!-- ─────────────────────────────────────────────── -->
            <!-- AI AUTOFILL SECTION -->
            <!-- ─────────────────────────────────────────────── -->
            <v-row>
              <v-col cols="12">
                <v-card outlined class="pa-4 mb-2" :class="aiMatchFound ? 'match-found-card' : 'upload-card'">
                  <!-- Match found warning -->
                  <v-alert v-if="aiMatchFound && aiExistingProduct" type="warning" dense class="mb-3">
                    ⚠️ This product already exists in the database!
                    <strong>{{ aiExistingProduct.SKU }}</strong> —
                    {{ aiExistingProduct.Brand }} {{ aiExistingProduct.Category }}
                  </v-alert>

                  <!-- Upload area (only show when not loading) -->
                  <div v-if="!aiLoading" class="ai-upload-area" @click="$refs.aiImageInput.click()" @dragover.prevent
                    @drop.prevent="handleAiDrop">
                    <v-icon size="36" color="accent">mdi-camera-plus</v-icon>
                    <p class="mt-2 mb-0 grey--text">
                      📸 Upload product photos for AI autofill
                    </p>
                    <p class="caption grey--text">
                      Click or drag & drop up to 5 images
                    </p>
                    <input ref="aiImageInput" type="file" accept="image/*" multiple style="display: none"
                      @change="handleAiImageUpload" />
                  </div>

                  <!-- Loading state -->
                  <div v-if="aiLoading" class="text-center pa-4">
                    <v-progress-circular indeterminate color="accent" size="40" />
                    <p class="mt-3 grey--text">
                      🤖 AI is analyzing your images...
                    </p>
                  </div>

                  <!-- Uploaded image chips + add more -->
                  <div v-if="aiImages.length && !aiLoading" class="mt-3 d-flex flex-wrap align-center">
                    <v-chip v-for="(img, i) in aiImages" :key="i" class="ma-1" close small
                      @click:close="removeAiImage(i)">
                      {{ img.name }}
                    </v-chip>
                    <v-btn small text color="accent" class="ml-2" @click="$refs.aiImageInput.click()">
                      + Add more
                    </v-btn>
                    <v-btn small text color="grey" class="ml-1" @click="clearAiImages">
                      Clear
                    </v-btn>
                  </div>

                  <!-- Autofill success badge -->
                  <div v-if="aiAutofilled.length && !aiLoading && !aiMatchFound" class="mt-2">
                    <v-chip small color="success" text-color="white">
                      <v-icon small left>mdi-robot</v-icon>
                      AI autofilled: {{ aiAutofilled.join(', ') }}
                    </v-chip>
                    <span class="caption grey--text ml-2">
                      Yellow fields were filled by AI — please review
                    </span>
                  </div>
                </v-card>
              </v-col>
            </v-row>
            <!-- ─────────────────────────────────────────────── -->
            <!-- END AI AUTOFILL SECTION -->
            <!-- ─────────────────────────────────────────────── -->

            <v-row class="mt-4">
              <v-col cols="12" sm="6" md="3" class="py-0">
                <!--
                  FIX 1: isCategoryLocked moved to `computed`, so :disabled is
                  now reactive. Previously it was a method in `methods`, which
                  Vue never called reactively — the category was always locked.
                -->
                <TreeSelect v-model="Category" style="padding-top: 0px; margin-top: 0px; width: 100%"
                  :class="aiAutofilled.includes('Category') ? 'ai-autofilled' : ''" :dropdown-style="{
                    maxHeight: '400px',
                    overflow: 'auto',
                  }" :tree-data="categories" :replaceFields="{
                    children: 'children',
                    title: 'name',
                    key: 'id',
                    value: 'path',
                  }" placeholder="Category" label="Category" filled @change="setCategoryFields" :disabled="isCategoryLocked" color="accent">
                </TreeSelect>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-autocomplete color="accent" label="Brand" v-model="Brand" type="text" :items="brands"
                  :rules="[rules.required]" :item-text="'brandName'" :item-value="'brandName'" outlined dense
                  @change="setBrandDetails(Brand)" clearable return-object
                  :class="aiAutofilled.includes('Brand') ? 'ai-autofilled' : ''">
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="RRP" v-model="RRP" type="number" min="0" :rules="type == 'description' ? [rules.required, rules.rrp] : []
                  " outlined dense clearable @change="formToggled" @wheel="$event.target.blur()">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="Pigu Price" v-model="PiguPrice" type="number" min="0"
                  :rules="type == 'description' ? [rules.rrp] : []" outlined dense clearable @change="formToggled"
                  @wheel="$event.target.blur()">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" v-model="Currency" label="Original currency" disabled outlined dense
                  clearable></v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-autocomplete color="accent" label="Condition" v-model="Condition" type="text" :items="conditions"
                  :rules="[rules.required]" :item-text="'condition'" :item-value="'id'" outlined dense
                  :background-color="title.includes('New variation from') ? '#F08080' : ''
                    " clearable>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="Wholesale price" v-model="WholesalePrice" type="number" outlined
                  dense min="0" clearable messages="Always write this price in EUR" append-icon="mdi-currency-eur"
                  :rules="[]" @change="formToggled" @wheel="$event.target.blur()">
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="ASIN" v-model="ASIN" outlined dense clearable :rules="[]"
                  @change="formToggled">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card tile>
          <v-card-title class="subtitle-1 accent" primary-title>
            <div>Optional information</div>
          </v-card-title>
          <v-card-text class="pb-0">
            <v-row class="mt-4">
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="Barcode" v-model="Barcode" type="text" outlined dense clearable>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-autocomplete color="accent" label="Manufacturing country" v-model="Country" type="text"
                  :items="manufacturCountries" outlined dense clearable>
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="Style code" v-model="StyleCode" type="text" outlined dense
                  clearable>
                </v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field color="accent" label="Style name" v-model="StyleName" type="text" outlined dense
                  clearable>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-select color="accent" v-model="ConditionDescription" :items="conditionDescriptions"
                  label="Select condition descriptions" multiple outlined dense clearable
                  :menu-props="{ maxHeight: 200 }" max-height="200" chips small-chips deletable-chips :background-color="title.includes('New variation from') ? '#F08080' : ''
                    "></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-autocomplete v-if="product.Defect && product.Defect.length > 0" v-model="Defect[0]" :items="defects"
                  label="Select defect" outlined dense clearable color="accent" :background-color="title.includes('New variation from') ? '#F08080' : ''
                    "></v-autocomplete>
                <v-autocomplete v-else v-model="Defect" :items="defects" label="Select defect" outlined dense clearable
                  color="accent" :background-color="title.includes('New variation from') ? '#F08080' : ''
                    "></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0" v-if="
                Defect.length > 0 ||
                (product.Defect && product.Defect.length > 0)
              ">
                <v-combobox v-model="DefectDescription" :items="DefectDescriptions" label="Defect description" outlined
                  dense clearable color="accent" :return-object="false"></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-autocomplete label="Gender" v-model="Gender" type="text" :items="genders"
                  @change="remakeFields(Gender)" outlined dense clearable color="accent"
                  :class="aiAutofilled.includes('Gender') ? 'ai-autofilled' : ''">
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row class="my-0">
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-combobox v-model="RealColor" :items="colors" label="Real color" :item-text="'realColor'"
                  :item-value="'realColor'" outlined dense clearable :return-object="false" color="accent"
                  :class="aiAutofilled.includes('RealColor') ? 'ai-autofilled' : ''"></v-combobox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-text-field label="Manufacturer color" v-model="ManufacturerColor" type="text" outlined dense
                  clearable color="accent" :class="aiAutofilled.includes('ManufacturerColor') ? 'ai-autofilled' : ''">
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="3" class="py-0" v-if="Brand && subBrands.length > 0">
                <v-autocomplete label="Sub-brand" v-model="SubBrand" type="text" :items="subBrands" outlined dense
                  clearable color="accent">
                </v-autocomplete>
              </v-col>
              <v-col v-if="Brand && product.Type == 'Decor'" cols="12" sm="6" md="3" class="py-0">
                <v-text-field label="Designer" v-model="Designer" type="text" outlined dense clearable color="accent">
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <CategoryConfigFields v-if="Category" :category="Category" :categories="categories" :product="product"
          :fillDynamic="fillDynamic" ref="categoryConf" :key="categoryConfKey" :dialogTitle="title" :type="type"
          @wrongCategory="wrongCategory" @toggledDynamicFields="formToggled" @toggledCompositionFields="formToggled"
          @dynamicFieldsFilled="dynamicFieldsFilled"></CategoryConfigFields>

        <v-expansion-panels flat tile v-model="DescPanel">
          <v-expansion-panel class="my-0 py-2">
            <v-expansion-panel-header color="accent" class="subtitle-1">
              Pigu.lt Descriptions
            </v-expansion-panel-header>
            <v-expansion-panel-content class="mt-4">
              <v-tabs v-model="DescTab">
                <v-tab>English Description</v-tab>
                <v-tab>Lithuanian Description</v-tab>
                <v-tab>Latvian Description</v-tab>
                <v-tab>Estonain Description</v-tab>
                <v-tab>Finnish Description</v-tab>
                <v-tab>Russian Description</v-tab>
              </v-tabs>
              <v-tabs-items class="mt-6" v-model="DescTab">
                <v-tab-item>
                  <VueEditor v-model="DescPiguEn"></VueEditor>
                </v-tab-item>
                <v-tab-item>
                  <VueEditor v-model="DescPiguLt"></VueEditor>
                </v-tab-item>
                <v-tab-item>
                  <VueEditor v-model="DescPiguLv"></VueEditor>
                </v-tab-item>
                <v-tab-item>
                  <VueEditor v-model="DescPiguEe"></VueEditor>
                </v-tab-item>
                <v-tab-item>
                  <VueEditor v-model="DescPiguFn"></VueEditor>
                </v-tab-item>
                <v-tab-item>
                  <VueEditor v-model="DescPiguRu"></VueEditor>
                </v-tab-item>
              </v-tabs-items>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-expansion-panels flat tile v-model="detailsPanel">
          <v-expansion-panel class="my-0 py-2">
            <v-expansion-panel-header color="accent" class="subtitle-1">
              Details
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-row class="mt-4">
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-autocomplete label="Season" v-model="Season[0]" type="text" :items="seasons" outlined dense
                    clearable color="accent" :class="aiAutofilled.includes('Season') ? 'ai-autofilled' : ''">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-autocomplete label="Themes" v-model="Theme" type="text" :items="themes" outlined dense clearable
                    color="accent">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-autocomplete label="Occasion" v-model="Occasion" type="text" :items="occasions" outlined dense
                    clearable color="accent">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-combobox v-if="Type == 'Decor'" label="Feature" v-model="Features[0]" type="text" :items="features"
                    outlined dense clearable :return-object="false" color="accent"
                    :class="aiAutofilled.includes('Features') ? 'ai-autofilled' : ''">
                  </v-combobox>
                  <v-autocomplete v-else label="Feature" v-model="Features[0]" type="text" :items="features" outlined
                    dense clearable :return-object="false" color="accent"
                    :class="aiAutofilled.includes('Features') ? 'ai-autofilled' : ''">
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="my-0">
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-combobox v-if="Type == 'Decor'" label="Accents" v-model="Accents[0]" type="text" :items="accents"
                    outlined dense clearable color="accent"
                    :class="aiAutofilled.includes('Accents') ? 'ai-autofilled' : ''">
                  </v-combobox>
                  <v-autocomplete v-else label="Accents" v-model="Accents[0]" type="text" :items="accents" outlined
                    dense clearable color="accent" :class="aiAutofilled.includes('Accents') ? 'ai-autofilled' : ''">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-autocomplete label="Pattern" v-model="Pattern" type="text" :items="patterns" outlined dense
                    clearable color="accent" :class="aiAutofilled.includes('Pattern') ? 'ai-autofilled' : ''">
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-autocomplete label="Garment care" v-model="GarmentCare" type="text" :items="garmentCares" outlined
                    dense clearable color="accent">
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row class="my-0">
                <v-col cols="12" sm="6" md="3" class="py-0">
                  <v-checkbox v-model="isASet" label="Is a set" color="accent">
                  </v-checkbox>
                </v-col>
                <v-col v-if="isASet" cols="12" sm="6" md="3" class="py-0">
                  <v-text-field label="Is a set of:" v-model="SetOf" type="text" outlined dense clearable
                    color="accent">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <v-card tile flat>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-checkbox v-model="BigDimensions" label="Big dimensions/Is heavy" color="accent">
                </v-checkbox>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0" v-if="type == 'registration'">
                <v-switch v-model="isVestiaire" color="accent" label="List on Vestiaire Collective" inset dense>
                  <template v-slot:label>
                    <span>
                      List on <strong>Vestiaire Collective</strong>
                      <v-chip x-small color="purple" text-color="white" class="ml-1">vestiaire</v-chip>
                    </span>
                  </template>
                </v-switch>
              </v-col>
              <v-col cols="12" sm="6" md="3" class="py-0">
                <v-textarea v-model="Notes" outlined dense label="Notes" rows="2" clearable color="accent"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card tile>
          <v-card-actions v-if="type == 'resolve'">
            <v-spacer></v-spacer>
            <v-btn outlined color="#81C784" @click="saveProductExported">Save as exported</v-btn>
            <v-btn outlined color="indigo" text @click="saveProductNotExported">Save as not exported</v-btn>
            <v-btn outlined text @click="closeDialog">Close</v-btn>
          </v-card-actions>
          <v-card-actions v-else>
            <v-spacer></v-spacer>
            <v-btn color="success" outlined @click="save">Continue</v-btn>
            <v-btn color="error" outlined @click="closeDialog">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-dialog persistent v-model="statusDialog" width="unset">
      <status-info :responseMessage="responseMessage" :filename="filename" :pending="pending" @close="closeStatusDialog"
        @showProductInfo="postSearch(product.SKU)" :textColor="textColor" :showCheckBtn="showCheckBtn"></status-info>
    </v-dialog>

    <v-snackbar top v-model="snackbar" color="#FF3232" class="white--text">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbarCat = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <!-----------------OLD LOCATION INPUT CARD---------------------------------------------->
    <OldLocationCard v-if="oldLocationCard" :SKU="product.SKU" @continueOldLocation="continueOldLocation"
      @onInputChange="setOldLocationVal"></OldLocationCard>

    <!-------------------------------------------------------------------------------------->

    <!-----------------ORDERING PHOTOS-------------------------------------------------->
    <OrderPhotos v-if="showPhotoOrdering" :SKU="skuForPhotos" @afterPhotosPut="afterPhotosPut"></OrderPhotos>
    <!---------------------------------------------------------------------------------->

    <!-----------------THE NEW SKU CARD----------------------------------------------------->
    <NewSkuCard v-if="newSKU" :newSKUValue="newSKUValue" @continueNewSKU="continueNewSKU"></NewSkuCard>
    <!-------------------------------------------------------------------------------------->
  </div>
</template>

<script>
import StatusInfo from "../organisms/StatusInfo";
import { TreeSelect } from "ant-design-vue";
import CategoryConfigFields from "./CategoryConfigFields.vue";
import OldLocationCard from "../Descriptions/OldLocationCard.vue";
import OrderPhotos from "../Descriptions/OrderPhotos.vue";
import NewSkuCard from "../Descriptions/NewSkuCard";

export default {
  name: "ProductDialog",
  components: {
    StatusInfo,
    TreeSelect,
    CategoryConfigFields,
    OldLocationCard,
    OrderPhotos,
    NewSkuCard,
  },
  props: {
    product: Object,
    initialProduct: Object,
    title: String,
    type: String,
    fillDynamic: Boolean,
    excludeKeys: Array,
    db: String,
  },
  data: () => ({
    aiAutofilling: false,
    DescTab: 0,
    DescPiguEn: "",
    DescPiguLt: "",
    DescPiguEe: "",
    DescPiguLv: "",
    DescPiguFn: "",
    DescPiguRu: "",

    dialog: false,
    statusDialog: false,
    snackbar: false,
    snackbarText: "",
    pending: false,
    responseMessage: "",
    textColor: "basic--text",
    filename: "",
    subBrands: [],
    categories: [],
    brands: [],
    colors: [],
    dropdownsData: [],
    manufacturCountries: [],
    conditions: [],
    conditionDescriptions: [],
    seasons: [],
    themes: [],
    occasions: [],
    defects: [],
    patterns: [],
    features: [],
    accents: [],
    closures: [],
    garmentCares: [],
    genders: [],
    rules: {
      required: (value) => !!value || "Field is required.",
      requiredMultiple: (value) => value.length > 0 || "Field is required",
      rrp: (value) => {
        if (value < 0) {
          return "Amount must be more than 0!";
        } else {
          return true;
        }
      },
      url: (value) => this.isURL(value) || "URL is not valid",
    },
    files: [],
    Accents: [],
    Barcode: undefined,
    BigDimensions: false,
    Brand: undefined,
    SubBrand: undefined,
    Designer: undefined,
    Category: undefined,
    Condition: undefined,
    ConditionDescription: [],
    Country: undefined,
    Currency: undefined,
    Defect: [],
    DefectDescription: "",
    DefectDescriptions: [],
    Features: [],
    GarmentCare: undefined,
    Gender: undefined,
    ManufacturerColor: undefined,
    Notes: undefined,
    Occasion: undefined,
    Pattern: undefined,
    Photos: [],
    RRP: undefined,
    RealColor: undefined,
    PiguPrice: undefined,
    Season: [],
    SetOf: [],
    StyleCode: undefined,
    StyleName: undefined,
    Theme: undefined,
    WholesalePrice: undefined,
    isASet: false,
    categoryConfKey: 0,
    detailsPanel: 0,
    DescPanel: 0,
    oldLocationCard: false,
    showDialog: false,
    oldLocation: "",
    showPhotoOrdering: false,
    skuForPhotos: "",
    SKUchanged: false,
    newSKU: false,
    newSKUValue: "",
    exportState: "",
    photoURLs: [],
    max: 100,
    photoError: false,
    showCheckBtn: false,
    productCopy: {},
    ASIN: "",
    Type: "",

    // ── AI autofill state ──
    aiLoading: false,
    aiImages: [],
    aiAutofilled: [],
    aiMatchFound: false,
    aiExistingProduct: null,
  }),
  computed: {
    current: {
      get: function () {
        let current = 0;
        if (this.product["Photos"]) {
          current = current + this.product["Photos"].length;
        }
        return current + this.files.length + this.photoURLs.length;
      },
      set: function (newValue) {
        if (this.product["Photos"]) {
          newValue = newValue + this.product["Photos"].length;
        }
        return newValue + this.files.length + this.photoURLs.length;
      },
    },

    // ─────────────────────────────────────────────────────────────────────────
    // FIX 1: Moved from methods to computed so Vue tracks it reactively.
    // Previously defined as a regular method, it was never called by Vue's
    // reactivity system, so :disabled on TreeSelect was always falsy (undefined)
    // — causing the category to appear locked (red circle, unclickable) because
    // Vuetify treated a non-reactive undefined as a truthy disabled state on the
    // first render. Now Vue re-evaluates this whenever title or aiAutofilled change.
    // ─────────────────────────────────────────────────────────────────────────
    isCategoryLocked() {
      // AI just picked a category → always let the user override it
      if (this.aiAutofilled.includes('Category')) return false;

      return (
        this.title === 'Add new variation' ||
        this.title.includes('Edit product') ||
        this.title.includes('Resolve product') ||
        this.title.includes('platform')
      );
    },
  },
  watch: {
    photoURLs(val) {
      if (val.length > 0) {
        this.current += val.length;
      }
    },
    files(val) {
      if (val.length > 0) {
        this.current += val.length;
      }
    },
  },

  async mounted() {
    await this.showProductForm();

    this.productCopy = JSON.stringify(this.product);

    if (this.type == "registration") {
      this.detailsPanel = null;
      this.DescPanel = null;
    }

    function isFile(evt) {
      var dt = evt.dataTransfer;
      for (var i = 0; i < dt.types.length; i++) {
        if (dt.types[i] === "Files") {
          return true;
        }
      }
      return false;
    }

    window.addEventListener("dragenter", function (e) {
      if (isFile(e)) {
        this.lastTarget = e.target;
        document.querySelector("#dropzone").style.visibility = "";
        document.querySelector("#dropzone").style.opacity = 1;
        document.querySelector("#textnode").style.fontSize = "48px";
      }
    });

    window.addEventListener("dragleave", function (e) {
      e.preventDefault();
      if (e.target === this.lastTarget || e.target === document) {
        document.querySelector("#dropzone").style.visibility = "hidden";
        document.querySelector("#dropzone").style.opacity = 0;
        document.querySelector("#textnode").style.fontSize = "42px";
      }
    });

    window.addEventListener("dragover", function (e) {
      e.preventDefault();
    });

    window.addEventListener("drop", (e) => {
      e.preventDefault();
      document.querySelector("#dropzone").style.visibility = "hidden";
      document.querySelector("#dropzone").style.opacity = 0;
      document.querySelector("#textnode").style.fontSize = "42px";
      if (e.dataTransfer.files.length > 0) {
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          const element = e.dataTransfer.files[i];
          this.files.push(element);
          this.validateFiles(this.files);
        }
      }
    });
  },

  methods: {
    resetFormFields() {
      this.Accents = [];
      this.Barcode = undefined;
      this.isVestiaire = false;
      this.BigDimensions = false;
      this.Brand = undefined;
      this.SubBrand = undefined;
      this.Designer = undefined;
      this.Category = undefined;
      this.Condition = undefined;
      this.ConditionDescription = [];
      this.Country = undefined;
      this.Currency = undefined;
      this.Defect = [];
      this.DefectDescription = "";
      this.DefectDescriptions = [];
      this.Features = [];
      this.GarmentCare = undefined;
      this.Gender = undefined;
      this.ManufacturerColor = undefined;
      this.Notes = undefined;
      this.Occasion = undefined;
      this.Pattern = undefined;
      this.Photos = [];
      this.RRP = undefined;
      this.RealColor = undefined;
      this.PiguPrice = undefined;
      this.Season = [];
      this.SetOf = [];
      this.StyleCode = undefined;
      this.StyleName = undefined;
      this.Theme = undefined;
      this.WholesalePrice = undefined;
      this.isASet = false;
      this.ASIN = "";
      this.Type = "";

      this.DescTab = 0;
      this.DescPiguEn = "";
      this.DescPiguLt = "";
      this.DescPiguEe = "";
      this.DescPiguLv = "";
      this.DescPiguFn = "";
      this.DescPiguRu = "";

      this.files = [];
      this.photoURLs = [];
      this.photoError = false;

      this.subBrands = [];
      this.showCheckBtn = false;
      this.SKUchanged = false;
      this.newSKU = false;
      this.newSKUValue = "";
      this.exportState = "";
      this.oldLocation = "";
      this.responseMessage = "";
      this.filename = "";
      this.textColor = "basic--text";

      this.aiLoading = false;
      this.aiImages = [];
      this.aiAutofilled = [];
      this.aiMatchFound = false;
      this.aiExistingProduct = null;
      this.aiAutofilling = false;

      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },

    // ─────────────────────────────────────────
    // AI AUTOFILL METHODS
    // ─────────────────────────────────────────
    handleAiDrop(e) {
      const files = Array.from(e.dataTransfer.files).filter((f) =>
        f.type.startsWith("image/")
      );
      if (files.length) this.runAiAutofill(files);
    },

    handleAiImageUpload(e) {
      const files = Array.from(e.target.files);
      if (files.length) this.runAiAutofill(files);
      e.target.value = "";
    },

    removeAiImage(index) {
      this.aiImages.splice(index, 1);
    },

    clearAiImages() {
      this.aiImages = [];
      this.aiAutofilled = [];
      this.aiMatchFound = false;
      this.aiExistingProduct = null;
    },

    async runAiAutofill(files) {
      this.aiImages = files;
      this.aiLoading = true;
      this.aiAutofilling = true;
      this.aiMatchFound = false;
      this.aiExistingProduct = null;
      this.aiAutofilled = [];

      try {
        const formData = new FormData();
        files.forEach((f) => formData.append("images", f));

        const result = await this.$store.dispatch("aiAutofillProducts", formData);
        const data = result.data;

        if (data.isMatch && data.existingProduct) {
          this.aiMatchFound = true;
          this.aiExistingProduct = data.existingProduct;
          this.applyAutofillFields(data.existingProduct);
        } else if (data.autofill) {
          this.applyAutofillFields(data.autofill);
        }

      } catch (e) {
        console.error("AI autofill failed:", e);
        this.snackbarText = "AI autofill failed, please fill manually.";
        this.snackbar = true;
      } finally {
        this.aiLoading = false;
        this.aiAutofilling = false;
      }
    },

    applyAutofillFields(af) {
      // ── Category ──
      if (af.Category) {
        const match = this.findCategoryByName(this.categories, af.Category);
        if (match) {
          this.Category = match.path;
          this.setCategoryFields();
          this.aiAutofilled.push("Category");
        }
      }

      // ── Brand ──
      if (af.Brand) {
        const match = this.brands.find(
          (b) => b.brandName.toLowerCase() === af.Brand.toLowerCase()
        );
        if (match) {
          this.Brand = match;
          this.setBrandDetails(match);
          this.aiAutofilled.push("Brand");
        }
      }

      // ── Gender ──
      if (af.Gender) {
        const match = this.genders.find(
          (g) => g.toLowerCase() === af.Gender.toLowerCase()
        );
        if (match) {
          this.Gender = match;
          if (this.$refs.categoryConf) {
            this.remakeFields(match);
          }
          this.aiAutofilled.push("Gender");
        }
      }

      // ── Season ──
      const seasonVal = Array.isArray(af.Season) ? af.Season[0] : af.Season;
      if (seasonVal) {
        const match = this.seasons.find(
          (s) => s.toLowerCase() === seasonVal.toLowerCase()
        );
        if (match) {
          if (!Array.isArray(this.Season)) this.Season = [];
          this.$set(this.Season, 0, match);
          this.aiAutofilled.push("Season");
          this.detailsPanel = 0;
        }
      }

      // ─────────────────────────────────────────────────────────────────────────
      // FIX 2: The original code had two separate `if (af.RealColor)` blocks that
      // both ran sequentially. The first block always pushed "RealColor" into
      // aiAutofilled (even on a bad match) and set this.RealColor to a potentially
      // wrong value. The second (better) block then checked aiAutofilled, which
      // already contained "RealColor", so it silently skipped — meaning the broken
      // first block always won. This collapsed them into one block using only the
      // correct matching logic (exact → unambiguous starts-with → skip).
      // ─────────────────────────────────────────────────────────────────────────
      if (af.RealColor) {
        const normalise = (s) => s.trim().toLowerCase();
        const aiColor = normalise(af.RealColor);

        // 1. Exact match
        let match = this.colors.find(
          (c) => normalise(c.realColor) === aiColor
        );

        // 2. Unambiguous starts-with (e.g. "black leather" → "black")
        if (!match) {
          const startMatches = this.colors.filter((c) =>
            aiColor.startsWith(normalise(c.realColor))
          );
          if (startMatches.length === 1) match = startMatches[0];
        }

        // Only autofill if we found a clear match — skip ambiguous cases
        if (match) {
          this.RealColor = match.realColor;
          this.aiAutofilled.push("RealColor");
        }
      }

      // ── ManufacturerColor ──
      if (af.ManufacturerColor) {
        this.ManufacturerColor = af.ManufacturerColor;
        this.aiAutofilled.push("ManufacturerColor");
      }

      // ── Pattern ──
      if (af.Pattern) {
        const match = this.patterns.find(
          (p) => p.toLowerCase() === af.Pattern.toLowerCase()
        );
        if (match) {
          this.Pattern = match;
          this.aiAutofilled.push("Pattern");
          this.detailsPanel = 0;
        }
      }

      // ── Accents ──
      if (af.Accents?.length) {
        const validMatches = af.Accents.reduce((acc, aiVal) => {
          const aiLower = aiVal.toLowerCase();
          const match = this.accents.find(
            (a) =>
              a.toLowerCase() === aiLower ||
              a.toLowerCase().includes(aiLower) ||
              aiLower.includes(a.toLowerCase())
          );
          if (match && !acc.includes(match)) acc.push(match);
          return acc;
        }, []);

        if (validMatches.length) {
          if (!Array.isArray(this.Accents)) this.Accents = [];
          this.$set(this.Accents, 0, validMatches[0]);
          this.aiAutofilled.push("Accents");
          this.detailsPanel = 0;
        }
      }

      // ── Features ──
      if (af.Features?.length) {
        const validMatches = af.Features.reduce((acc, aiVal) => {
          const aiLower = aiVal.toLowerCase();
          const match = this.features.find(
            (f) =>
              f.toLowerCase() === aiLower ||
              f.toLowerCase().includes(aiLower) ||
              aiLower.includes(f.toLowerCase())
          );
          if (match && !acc.includes(match)) acc.push(match);
          return acc;
        }, []);

        if (validMatches.length) {
          if (!Array.isArray(this.Features)) this.Features = [];
          this.$set(this.Features, 0, validMatches[0]);
          this.aiAutofilled.push("Features");
          this.detailsPanel = 0;
        }
      }
    },

    findCategoryByName(categories, name) {
      const nameLower = name.toLowerCase();
      let bestMatch = null;

      const search = (nodes) => {
        for (const cat of nodes) {
          const catLower = cat.name.toLowerCase();
          if (
            catLower === nameLower ||
            catLower.includes(nameLower) ||
            nameLower.includes(catLower)
          ) {
            if (!bestMatch || (cat.forUse && !bestMatch.forUse) ||
              (cat.forUse === bestMatch.forUse && !cat.children)) {
              bestMatch = cat;
            }
          }
          if (cat.children?.length) search(cat.children);
        }
      };

      search(categories);
      return bestMatch;
    },

    // ─────────────────────────────────────────
    // EXISTING METHODS
    // ─────────────────────────────────────────

    dynamicFieldsFilled() {
      this.dynamicFilled = true;
    },

    formToggled() {
    },

    async cashProduct() {
      if (this.dynamicFilled) {
        let product = {
          Accents: this.Accents,
          Barcode: this.Barcode,
          Brand: this.Brand.brandName,
          SubBrand: this.SubBrand,
          Category: this.Category,
          Condition: this.Condition,
          ConditionDescription: this.ConditionDescription,
          Country: this.Country,
          Currency: this.Currency,
          Defect: this.Defect,
          Features: this.Features,
          GarmentCare: this.GarmentCare,
          Gender: this.Gender,
          ManufacturerColor: this.ManufacturerColor,
          Notes: this.Notes,
          Occasion: this.Occasion,
          Pattern: this.Pattern,
          RRP: parseFloat(this.RRP),
          PiguPrice: parseFloat(this.PiguPrice),
          Season: this.Season,
          SetOf: this.SetOf,
          StyleCode: this.StyleCode,
          StyleName: this.StyleName,
          Theme: this.Theme,
          WholesalePrice: parseFloat(this.WholesalePrice),
          Type: this.product.Type,
          SKU: this.product.SKU,
          ASIN: this.ASIN,
          DescPiguEe: this.DescPiguEe,
          DescPiguEn: this.DescPiguEn,
          DescPiguLt: this.DescPiguLt,
          DescPiguLv: this.DescPiguLv,
          DescPiguFn: this.DescPiguFn,
          DescPiguRu: this.DescPiguRu,
        };

        if (this.RealColor) {
          product.RealColor = this.RealColor.trim();
        }
        if (this.DefectDescription) {
          product["DefectDescription"] = this.DefectDescription.trim();
        }
        if (!Array.isArray(this.Defect)) {
          product["Defect"] = [this.Defect];
        }
        if (this.type != "registration" && this.Photos.length > 0) {
          product["Photos"] = this.Photos;
        }
        if (this.BigDimensions) {
          product["Big Dimensions"] = true;
        }
        if (this.isASet) {
          product["isASet"] = true;
        }
        if (this.product["ExportState"]) {
          product["ExportState"] = this.product["ExportState"];
        }
        if (this.product["descriptionType"]) {
          product["descriptionType"] = this.product["descriptionType"];
        }

        product["Configured"] = await this.$refs.categoryConf.getData();
        product = await this.refactorConfiguredFields(product);
        await this.$store.dispatch("saveCashedProduct", product);
      }
    },

    async saveCashedProduct(product) {
      await this.$store.dispatch("saveCashedProduct", product);
    },

    postSearch(sku) {
      this.$emit("postSkuSearch", sku);
    },

    validateFiles(files) {
      for (const i in files) {
        let objectUrl = URL.createObjectURL(files[i]);
        const img = new Image();

        img.onload = () => {
          if (!(img.width >= 500 || img.height >= 500)) {
            this.snackbarText = `${files[i].name} file dimensions are too small: ${img.width}x${img.height}. At least one dimension should be 500px.`;
            this.snackbar = true;
            this.files.splice(parseInt(i), 1);
          }
        };

        img.src = objectUrl;
      }
    },

    isURL(urlArray) {
      let url;
      let validation = [];
      for (const str of urlArray) {
        try {
          url = new URL(str);
        } catch (_) {
          return false;
        }
        if (url.protocol === "http:" || url.protocol === "https:") {
          validation.push("valid");
        } else {
          validation.push("invalid");
        }
      }

      if (validation.includes("invalid")) {
        return "URLs are not valid";
      } else {
        return true;
      }
    },

    skipDescription() {
      this.$emit("skipDescription", this.product.SKU);
    },

    wrongCategory() {
      this.Category = undefined;
    },

    maxRule() {
      if (this.current > this.max) {
        this.photoError = true;
        return `There could be max ${this.max} file(s)`;
      } else if (this.current == 0) {
        this.photoError = true;
        return "Photos are required!";
      } else {
        this.photoError = false;
        return true;
      }
    },

    closeDialog() {
      this.dialog = false;
      this.resetFormFields();
      this.$emit("closeDialog");
    },

    async showProductForm() {
      this.resetFormFields();

      this.statusDialog = true;
      this.pending = true;

      await this.fillDropdowns();
      await this.getDefectDescriptions();

      if (this.title != "Add new product") {
        this.Brand = await this.getBrandObj(this.product.Brand);
        this.setBrandDetails(this.Brand);
      }
      await this.fillFields(this.excludeKeys);

      this.statusDialog = false;
      this.pending = false;
      this.showDialog = true;
      this.dialog = true;
    },

    refactorConfiguredFields(product) {
      const productConfiguredFields = product["Configured"];

      for (let i = 0; i < productConfiguredFields.length; i++) {
        if (
          product[productConfiguredFields[i].Purpose] == undefined ||
          product[productConfiguredFields[i].Purpose] == null ||
          product[productConfiguredFields[i].Purpose] == ""
        ) {
          product[productConfiguredFields[i].Purpose] = {};
        }
        product[productConfiguredFields[i].Purpose][
          productConfiguredFields[i].Name
        ] = productConfiguredFields[i].Value;
      }

      delete product["Configured"];
      return product;
    },

    async getDefectDescriptions() {
      try {
        const requestDefectDescriptions = await this.$store.dispatch(
          "getDefectDescriptions",
          encodeURIComponent(this.Category)
        );
        this.DefectDescriptions = requestDefectDescriptions.data;
      } catch (error) {
        console.log(error);
      }
    },

    async fillFields(excludeKeys) {
      excludeKeys.push("Brand");
      for (const [key, value] of Object.entries(this.product)) {
        if (!excludeKeys.includes(key)) {
          this[key] = value;
        }
      }
      this.BigDimensions = this.product["Big Dimensions"]
        ? this.product["Big Dimensions"]
        : false;
    },

    async fillDropdowns() {
      this.statusDialog = true;
      this.pending = true;
      try {
        const requestCategories = this.$store.dispatch("getCategories");
        const requestBrands = this.$store.dispatch("getBrands");
        const requestColors = this.$store.dispatch("getColors");
        const requestDropdowns = this.$store.dispatch("getDropdowns");

        const responses = await Promise.all([
          requestCategories,
          requestBrands,
          requestColors,
          requestDropdowns,
        ]);
        const responseCategories = responses[0];
        const responseBrands = responses[1];
        const responseColors = responses[2];
        const responseDropdowns = responses[3].data;
        this.categories = responseCategories.data;
        this.brands = responseBrands.data;
        this.colors = responseColors.data;
        this.dropdownsData.push(responseDropdowns);
        this.manufacturCountries = responseDropdowns.country.sort();
        this.conditions = responseDropdowns.condition.sort();
        this.conditionDescriptions = responseDropdowns.description.sort();
        this.seasons = responseDropdowns.season.sort();
        this.themes = responseDropdowns.theme.sort();
        this.occasions = responseDropdowns.occassion.sort();
        this.defects = responseDropdowns.defect.sort();
        this.patterns = responseDropdowns.pattern.sort();
        this.features = responseDropdowns.features.sort();
        this.accents = responseDropdowns.accents.sort();
        this.closures = responseDropdowns["closure type"].sort();
        this.garmentCares = responseDropdowns["garment care"].sort();
        this.genders = responseDropdowns.gender.sort();
        this.statusDialog = false;
        this.pending = false;
      } catch (error) {
        this.responseMessage = error.response.data;
        this.pending = false;
        if (error.response.data) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          this.responseMessage =
            "Sorry... Something went wrong while getting dropdowns data.";
          this.filename = "feeling_blue.svg";
        }
      }
    },

    async getBrandObj(brandName) {
      var brand = this.brands.find((brand) => {
        return brand.brandName == brandName;
      });
      return brand;
    },

    async setBrandDetails(brand) {
      try {
        const response = await this.$store.dispatch("getBrand", brand.id);
        this.subBrands =
          response.data.subBrand != "" ? response.data.subBrand.split(",") : [];
        this.Currency = response.data.originalCurrency;
      } catch (error) {
        console.log(error);
      }
    },

    // ─────────────────────────────────────────────────────────────────────────
    // FIX 3: The original save() called this.$refs.categoryConf.fieldsValidation()
    // unconditionally. CategoryConfigFields is rendered with v-if="Category", so
    // when no category is selected (or the ref isn't mounted yet) this throws a
    // silent TypeError and the entire save flow is aborted — the button appears
    // to do nothing. Now we guard with a null-check and show a clear error instead.
    // ─────────────────────────────────────────────────────────────────────────
    async save() {
      const formValid = this.$refs.form.validate();

      // CategoryConfigFields is only mounted when a Category is selected (v-if).
      // Guard against it being absent and surface a clear message to the user.
      const categoryConfValid = this.$refs.categoryConf
        ? this.$refs.categoryConf.fieldsValidation()
        : true; // no category-specific fields to validate yet

      if (!this.Category) {
        this.snackbarText = "Please select a category before continuing.";
        this.snackbar = true;
        return;
      }

      if (formValid && categoryConfValid) {
        this.pending = true;
        this.statusDialog = true;
        this.textColor = "basic--text";
        this.dialog = false;
        this.$emit("hideResults");
        await this.formatProductBody();
      } else {
        this.snackbarText = "The form is filled incorrectly!";
        this.snackbar = true;
      }
    },

    reset() { },

    closeStatusDialog() {
      this.statusDialog = false;
      this.$emit("closedStatusDialog");
    },

    remakeFields(gender) {
      this.$refs.categoryConf.genderChanged(gender);
    },

    async formatProductBody(location) {
      let product = {
        Accents: this.Accents,
        Barcode: this.Barcode,
        Brand: this.Brand.brandName,
        SubBrand: this.SubBrand,
        Category: this.Category,
        Condition: this.Condition,
        ConditionDescription: this.ConditionDescription,
        Country: this.Country,
        Currency: this.Currency,
        Defect: this.Defect,
        Features: this.Features,
        GarmentCare: this.GarmentCare,
        Gender: this.Gender,
        ManufacturerColor: this.ManufacturerColor,
        Notes: this.Notes,
        Occasion: this.Occasion,
        Pattern: this.Pattern,
        RRP: parseFloat(this.RRP),
        PiguPrice: parseFloat(this.PiguPrice),
        Season: this.Season,
        SetOf: this.SetOf,
        StyleCode: this.StyleCode,
        StyleName: this.StyleName,
        Theme: this.Theme,
        WholesalePrice: parseFloat(this.WholesalePrice),
        Type: this.product.Type,
        ASIN: this.ASIN,
        DescPiguEe: this.DescPiguEe,
        DescPiguEn: this.DescPiguEn,
        DescPiguLt: this.DescPiguLt,
        DescPiguLv: this.DescPiguLv,
        DescPiguFn: this.DescPiguFn,
        DescPiguRu: this.DescPiguRu,
      };

      if (this.RealColor) {
        product.RealColor = this.RealColor.trim();
      }
      if (this.DefectDescription) {
        product["DefectDescription"] = this.DefectDescription.trim();
      }
      if (this.Type == "Decor") {
        product["Designer"] = this.Designer;
      }
      if (!Array.isArray(this.Defect)) {
        product["Defect"] = [this.Defect];
      }
      if (this.type == "registration") {
        product["Location"] = this.product.Location;
      }
      if (this.type != "registration" && this.Photos.length > 0) {
        product["Photos"] = this.Photos;
      }
      if (this.BigDimensions) {
        product["Big Dimensions"] = true;
      }
      if (this.isASet) {
        product["isASet"] = true;
      }
      if (this.product["ExportState"]) {
        product["ExportState"] = this.product["ExportState"];
      }
      if (this.product["descriptionType"]) {
        product["descriptionType"] = this.product["descriptionType"];
      }

      product["Configured"] = await this.$refs.categoryConf.getData();

      if (!location) {
        await this.selectMethod(product);
      }
      if (location) {
        product["Location"] = location;

        if (this.title.includes("Resolve product")) {
          this.resolveProduct(product);
        } else if (
          this.title.includes("Describe product") ||
          this.title.includes("Edit product") ||
          this.title.includes("New variation from")
        ) {
          this.describeProduct(product);
        }
      }
    },

    async selectMethod(product) {
      let skuChanged = false;
      if (this.title.includes("Add new variation")) {
        this.addNewVariation(product);
      }
      if (this.title.includes("Add new product")) {
        this.addNewProduct(product);
      }
      if (this.title.includes("Resolve product")) {
        this.resolveProduct(product);
      }
      if (this.title.includes("for platform upload")) {
        this.resolveProductPlatform(product);
      }
      if (
        this.title.includes("Describe product") ||
        this.title.includes("Edit product")
      ) {
        if (this.initialProduct) {
          skuChanged = await this.checkSkuChange(this.initialProduct, product);
        } else {
          skuChanged = await this.checkSkuChange(
            JSON.parse(this.productCopy),
            product
          );
        }

        if (skuChanged == "oldSKU") {
          this.describeProduct(product);
        } else {
          this.showDialog = false;
          this.statusDialog = false;
          this.oldLocationCard = true;
        }
      }
      if (this.title.includes("New variation from")) {
        this.showDialog = false;
        this.statusDialog = false;
        this.oldLocationCard = true;
      }
    },

    async checkSkuChange(oldVariation, newVariation) {
      let refactoredNewVariation = await this.refactorConfiguredFields(
        newVariation,
        "sku"
      );

      if (oldVariation["Condition"] != refactoredNewVariation["Condition"]) {
        if (
          refactoredNewVariation["Condition"] !== "With tag(s)" &&
          refactoredNewVariation["Condition"] !== "With box" &&
          refactoredNewVariation["Condition"] !== "With original packaging"
        ) {
          return "newSKU";
        } else {
          if (
            refactoredNewVariation["Barcode"] === "" ||
            refactoredNewVariation["Barcode"] === undefined ||
            refactoredNewVariation["Barcode"] === null
          ) {
            return "newSKU";
          } else {
            return "newSKU";
          }
        }
      }
      if (
        this.arrayEquals(
          oldVariation["ConditionDescription"],
          refactoredNewVariation["ConditionDescription"]
        ) == false &&
        refactoredNewVariation["ConditionDescription"] !== "" &&
        refactoredNewVariation["ConditionDescription"] !== undefined &&
        refactoredNewVariation["ConditionDescription"] !== null
      ) {
        return "newSKU";
      }
      if (
        this.arrayEquals(
          oldVariation["Defect"],
          refactoredNewVariation["Defect"]
        ) == false &&
        refactoredNewVariation["Defect"] !== "" &&
        refactoredNewVariation["Defect"] !== undefined &&
        refactoredNewVariation["Defect"] !== null
      ) {
        return "newSKU";
      }
      if (
        this.isEquivalent(oldVariation["Size"], newVariation["Size"]) == false
      ) {
        return "newSKU";
      }

      return "oldSKU";
    },

    isEquivalent(a, b) {
      var aProps = undefined;
      var bProps = undefined;
      if (a != undefined) {
        aProps = Object.getOwnPropertyNames(a);
      }
      if (b != undefined) {
        bProps = Object.getOwnPropertyNames(b);
      }

      if (a == undefined && b == undefined) {
        return true;
      } else if (a == undefined && b != undefined) {
        return false;
      } else if (a != undefined && b == undefined) {
        return false;
      }

      if (aProps.length != bProps.length) {
        return false;
      }

      for (var i = 0; i < aProps.length; i++) {
        var propName = aProps[i];
        if (a[propName] !== b[propName]) {
          return false;
        }
      }

      return true;
    },

    arrayEquals(a, b) {
      return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index])
      );
    },

    async addNewVariation(product) {
      let body = {
        newVariation: product,
        product: {
          SKU: this.product.SKU,
        },
      };

      try {
        const response = await this.$store.dispatch("postVariation", body);
        this.pending = false;
        this.responseMessage =
          "Success! A variation was created with SKU " + response.data.SKU;
        this.filename = "high_five.svg";
      } catch (error) {
        console.log(error);
        this.textColor = "red--text";
        this.pending = false;
        this.responseMessage = error.response.data;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          this.filename = "feeling_blue.svg";
          this.responseMessage = "SORRY... Something went wrong.";
        }
      }
    },

    async addNewProduct(product) {
      let body = {
        product: product,
        isVestiaire: this.isVestiaire,
      };

      try {
        const response = await this.$store.dispatch("postProduct", body);
        this.pending = false;
        this.responseMessage =
          "Success! A product was created with SKU " + response.data.SKU;
        this.filename = "high_five.svg";
      } catch (error) {
        console.log(error);
        this.textColor = "red--text";
        this.pending = false;
        this.responseMessage = error.response.data;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          this.filename = "feeling_blue.svg";
          this.responseMessage = "SORRY... Something went wrong.";
        }
      }
    },

    async resolveProductPlatform(product) {
      product["SKU"] = this.product.SKU;
      if (this.photoURLs.length > 0) {
        product["photoLinks"] = this.photoURLs;
      }
      let formData = new FormData();
      formData.append("product", JSON.stringify(product));

      if (this.files.length > 0) {
        for (let i in this.files) {
          formData.append("files", this.files[i]);
        }
      }

      try {
        const response = await this.$store.dispatch(
          "resolveProductPlatform",
          formData
        );
        this.statusDialog = false;
        this.skuForPhotos = response.data.SKU;
        this.$emit("hideTable");
        this.showPhotoOrdering = true;
      } catch (error) {
        console.log(error);
        this.textColor = "red--text";
        this.pending = false;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          this.filename = "feeling_blue.svg";
          this.responseMessage = "SORRY... Something went wrong.";
        }
      }
    },

    setCategoryFields() {
      this.categoryConfKey++;
    },

    showErrors(status, message) {
      this.responseMessage = message;
      switch (status) {
        case 400:
          this.filename = "empty.svg";
          break;
        case 401:
          localStorage.clear();
          this.$router.push("login");
          break;
        case 403:
          this.filename = "403_forbidden.svg";
          break;
        case 404:
          this.responseMessage = "Bad request. Please contact TECH team.";
          this.filename = "void.svg";
          break;
        case 500:
          this.filename = "server_down.svg";
      }
    },

    async describeProduct(product) {
      product["SKU"] = this.product.SKU;
      if (this.photoURLs.length > 0) {
        product["photoLinks"] = this.photoURLs;
      }
      let formData = new FormData();
      formData.append("product", JSON.stringify(product));

      if (this.files.length > 0) {
        for (let i in this.files) {
          formData.append("files", this.files[i]);
        }
      }

      try {
        const response = await this.$store.dispatch("putProduct", formData);
        if (this.product.SKU != response.data.SKU) {
          this.SKUchanged = true;
          this.newSKUValue = response.data.SKU;
        }

        this.statusDialog = false;
        this.skuForPhotos = response.data.SKU;
        this.showPhotoOrdering = true;

      } catch (error) {
        console.log(error);
        this.textColor = "red--text";
        this.pending = false;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          this.filename = "feeling_blue.svg";
          this.responseMessage = "SORRY... Something went wrong.";
        }
      }
    },

    async clearCashedData(sku) {
      if (sku.includes("/")) {
        sku = sku.replace(/\//g, "%2F");
      }
      try {
        const response = await this.$store.dispatch(
          "clearUserInputCaching",
          sku
        );
        console.log(response);
      } catch (error) {
        console.log(error);
      }
    },

    setOldLocationVal(val) {
      this.oldLocation = val;
    },

    continueOldLocation() {
      this.oldLocationCard = false;
      this.pending = true;
      this.statusDialog = true;
      this.formatProductBody(this.oldLocation);
    },

    afterPhotosPut() {
      this.showPhotoOrdering = false;
      if (this.SKUchanged) {
        this.newSKU = true;
      } else {
        this.statusDialog = true;
        this.pending = false;
        this.responseMessage = `Success! Product ${this.product.SKU} was updated.`;
        this.filename = "high_five.svg";
        this.textColor = "basic--text";
        if (this.type == "description") this.showCheckBtn = true;
      }
    },

    saveProductExported() {
      if (
        this.$refs.form.validate() &&
        this.$refs.categoryConf.fieldsValidation()
      ) {
        this.pending = true;
        this.statusDialog = true;
        this.textColor = "basic--text";
        this.dialog = false;
        this.$emit("hideResults");
        this.product["ExportState"] = "Exported";
        this.formatProductBody();
      } else {
        this.snackbarText = "The form is filled incorrectly!";
        this.snackbar = true;
      }
    },

    saveProductNotExported() {
      if (
        this.$refs.form.validate() &&
        this.$refs.categoryConf.fieldsValidation()
      ) {
        this.pending = true;
        this.statusDialog = true;
        this.textColor = "basic--text";
        this.dialog = false;
        this.$emit("hideResults");
        this.product["ExportState"] = "Not Exported";
        this.formatProductBody();
      } else {
        this.snackbarText = "The form is filled incorrectly!";
        this.snackbar = true;
      }
    },

    async resolveProduct(product) {
      product["SKU"] = this.product.SKU;
      try {
        let response = await this.$store.dispatch(
          "putResolvedProduct",
          product
        );
        console.log(response);
        this.statusDialog = false;
        this.skuForPhotos = this.product.SKU;
        this.$emit("hideTable");
        this.showPhotoOrdering = true;
      } catch (error) {
        console.log(error);
        this.textColor = "red--text";
        this.pending = false;
        if (error.response) {
          this.showErrors(error.response.status, error.response.data);
        } else {
          this.filename = "feeling_blue.svg";
          this.responseMessage = "SORRY... Something went wrong.";
        }
      }
    },

    deletePhoto(item, i) {
      this.product["Photos"].splice(i, 1);
      this.$store
        .dispatch("deletePhoto", {
          SKU: this.product["SKU"],
          photoLink: item,
        })
        .then(() => {
          this.textColor = "basic--text";
        })
        .catch((error) => {
          console.log(error);
        });
    },

    continueNewSKU() {
      if (this.title.includes("Resolve product")) {
        this.newSKU = false;
        this.statusDialog = false;
        this.$emit("closedStatusDialog");
      } else {
        this.$router.go();
      }
    },
  },
};
</script>

<style>
div#text {
  margin-top: 48px;
  text-align: center;
}

div#dropzone {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999999999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: visibility 175ms, opacity 175ms;
  display: table;
  text-shadow: 1px 1px 2px #000;
  color: #fff;
  background: rgba(0, 0, 0, 0.45);
  font: bold 42px Oswald, DejaVu Sans, Tahoma, sans-serif;
}

div#textnode {
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  transition: font-size 175ms;
}

/* ── AI Autofill styles ── */
.ai-upload-area {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 24px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s;
}

.ai-upload-area:hover {
  border-color: var(--v-accent-base);
}

.upload-card {
  border-color: #e0e0e0 !important;
}

.match-found-card {
  border-color: #ff9800 !important;
  background-color: #fff8f0 !important;
}

.ai-autofilled .v-input__slot {
  background-color: #fffde7 !important;
}

.ai-autofilled {
  border-radius: 4px;
}
</style>